"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findConditionalTokens = void 0;
const errors_1 = require("../../errors");
const lib_1 = require("../../lib");
const transformations_1 = require("../../transformations");
const findConditionalTokens = (html) => {
    return [...html.matchAll((0, lib_1.getConditionalTokenRegexp)())].map((match) => {
        const [tokenString, encodedTokenData] = match;
        try {
            return {
                data: (0, transformations_1.dataFromBase64)(encodedTokenData),
                position: { from: match.index, to: match.index + tokenString.length },
            };
        }
        catch (error) {
            throw new errors_1.ConditionalTokenParseError(tokenString);
        }
    });
};
exports.findConditionalTokens = findConditionalTokens;
//# sourceMappingURL=find-conditional-tokens.js.map